/* Vegan LifeMoss build-your-own bundle: pick N products, the lowest-priced one is free. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function fmt(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function init(box) {
    if (box.__byob) return; box.__byob = true;
    var need = +box.getAttribute('data-need') || 4;
    var name = box.getAttribute('data-name') || 'Build Your Own Bundle';
    var code = box.getAttribute('data-code') || '';
    var picks = []; // array of item elements, in pick order
    var items = Array.prototype.slice.call(box.querySelectorAll('.vh-byob__item'));
    var slots = Array.prototype.slice.call(box.querySelectorAll('.vh-byob__slot'));
    var slotText = slots.map(function (s) { return s.querySelector('.vh-byob__slot-txt').innerHTML; });
    var status = box.querySelector('[data-status]'), bar = box.querySelector('[data-bar]');
    var subEl = box.querySelector('[data-sub]'), freeEl = box.querySelector('[data-free]'), totEl = box.querySelector('[data-total]');
    var addBtn = box.querySelector('[data-addall]');
    var addLabel = addBtn.innerHTML;

    function count(it) { return picks.filter(function (p) { return p === it; }).length; }
    function render() {
      items.forEach(function (it) {
        var n = count(it), minus = it.querySelector('[data-minus]'), num = it.querySelector('[data-n]'), plus = it.querySelector('[data-plus]');
        if (!plus) return;
        minus.hidden = num.hidden = n === 0;
        num.textContent = n;
        plus.disabled = picks.length >= need;
        it.classList.toggle('is-picked', n > 0);
      });
      var prices = picks.map(function (p) { return +p.getAttribute('data-price'); });
      var sub = prices.reduce(function (a, b) { return a + b; }, 0);
      var full = picks.length >= need;
      var free = full ? Math.min.apply(null, prices) : 0;
      var freeIdx = full ? prices.indexOf(free) : -1;
      slots.forEach(function (s, i) {
        var p = picks[i];
        s.classList.toggle('is-filled', !!p);
        s.classList.toggle('is-freebie', i === freeIdx);
        if (p) {
          s.innerHTML = '<img src="' + p.getAttribute('data-img') + '" alt="" width="44" height="44">' +
            '<span class="vh-byob__slot-txt"><b>' + esc(p.getAttribute('data-title')) + '</b><small>' + (i === freeIdx ? 'FREE' : fmt(+p.getAttribute('data-price'))) + '</small></span>' +
            '<button type="button" class="vh-byob__x" data-x="' + i + '" aria-label="Remove ' + esc(p.getAttribute('data-title')) + '">×</button>';
        } else {
          s.innerHTML = '<span class="vh-byob__slot-ic" aria-hidden="true">' + (i === slots.length - 1 ? '★' : (i + 1)) + '</span><span class="vh-byob__slot-txt">' + slotText[i] + '</span>';
        }
      });
      var left = need - picks.length;
      status.textContent = full ? 'Unlocked! Your ' + (need) + 'th item is free.' : (left === need ? 'Pick ' + need + ' to get 1 free' : 'Add ' + left + ' more to unlock your free item');
      box.classList.toggle('is-full', full);
      bar.style.width = (picks.length / need * 100) + '%';
      subEl.textContent = fmt(sub); subEl.style.visibility = full ? 'visible' : 'hidden';
      freeEl.textContent = '−' + fmt(free);
      totEl.textContent = fmt(sub - free);
      addBtn.disabled = !full;
      addBtn.innerHTML = full ? addLabel : 'Pick ' + left + ' more';
      var mob = box.querySelector('[data-mobcount]');
      if (mob) mob.textContent = picks.length + '/' + need;
    }
    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-plus],[data-minus],[data-x]');
      if (!t) return;
      if (t.hasAttribute('data-x')) { picks.splice(+t.getAttribute('data-x'), 1); render(); return; }
      var it = t.closest('.vh-byob__item');
      if (t.hasAttribute('data-plus')) { if (picks.length < need) picks.push(it); }
      else { var i = picks.lastIndexOf(it); if (i > -1) picks.splice(i, 1); }
      render();
    });
    box.querySelectorAll('.vh-byob__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var k = tab.getAttribute('data-key');
        box.querySelectorAll('.vh-byob__tab').forEach(function (o) { o.setAttribute('aria-pressed', o === tab ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = !!k && it.getAttribute('data-cats').indexOf(',' + k + ',') < 0; });
      });
    });
    addBtn.addEventListener('click', function () {
      if (picks.length < need) return;
      var map = {};
      picks.forEach(function (p) { var id = p.getAttribute('data-id'); map[id] = (map[id] || 0) + 1; });
      var payload = Object.keys(map).map(function (id) { return { id: +id, quantity: map[id], properties: { _bundle: name } }; });
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: payload }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return code ? fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : null; })
        .then(function () {
          addBtn.textContent = 'Added ✓';
          picks = []; setTimeout(render, 1800);
          try { if (window.upcartRefreshCart) window.upcartRefreshCart(); if (window.upcartOpenCart) { window.upcartOpenCart(); return; } } catch (e) {}
          window.location.href = root + 'cart';
        })
        .catch(function (err) { addBtn.disabled = false; addBtn.innerHTML = addLabel; alertMsg((err && (err.description || err.message)) || 'Sorry, that could not be added.'); });
    });
    function alertMsg(t) { status.textContent = t; }
    // phone bar toggle
    var panel = box.querySelector('.vh-byob__panel');
    var head = panel.querySelector('.vh-byob__panel-head');
    var tog = document.createElement('button');
    tog.type = 'button'; tog.className = 'vh-byob__toggle'; tog.setAttribute('aria-expanded', 'false');
    tog.innerHTML = '<span data-mobcount>0/' + need + '</span> View bundle';
    head.appendChild(tog);
    tog.addEventListener('click', function () { var o = panel.classList.toggle('is-open'); tog.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    render();
  }
  function boot() { document.querySelectorAll('[data-vh-byob]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
